import React, { useContext, useEffect, useState } from "react";
import * as PolicyProvider from "./Ctx";
import { policyAllow } from "./allow";

export let POLICIES = [];

export { policyAllow } from "./allow";

const Policy = ({ policy, children, feedback = "", init = null }) => {
  const { policies,policy_error } = useContext(PolicyProvider.Context);
  const [allow, setAllow] = useState(false);


  POLICIES = policies;


  useEffect(() => {
    setAllow(policyAllow(policy, POLICIES));
  }, [POLICIES]);

  useEffect(() => {
    if (allow && init) {
      init();
    }
  }, [allow]);

  if (allow) {
    return children;
  }

  return feedback ? feedback : null;
};

export default Policy;
